import React from "react";
import classnames from "classnames";

export interface TextProps {
  children: React.ReactNode;
  tag: string;
  color?: string;
  center?: boolean;
  classes?: string;
}

export interface TextState {}

export const Text = (props: TextProps) => {
  const { children, tag, center, color, classes } = props;
  const Tag = `${tag}` as keyof JSX.IntrinsicElements;
  return (
    <Tag
      className={`${classes ? classes : ""} ${classnames({
        "text-center": center,
        [color as string]: color,
      })}`}
    >
      {children}
    </Tag>
  );
};

export default Text;
